import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import "./edit-dashboard.sass";
import { ErrorField } from "../create-dashboard/create-dashboard";
import { useEffect, useState } from "react";
import { useStore } from "../../hooks-store/store";
import { LoadingScreen } from "../loadingspinner/loading-screen";
import Select from "react-select";
import { getReportingLinks } from "../../pages/reporting/links";
import { sendCallToAPI } from "../../common/generic_functions";
import { PERMISSIONS } from "../../common/constants";
import { DebouncedInput } from "../debounce-input/debounce-input";
import CreatetableSelect from "react-select/creatable";

export const EditDashboard = ({ toggleEditDashboard, reportingId, reportName, loadReports, setShowSuccessAlert, reportPermissions }) => {
  return (
    <div>
      <div className="symbol">
        <span className="material-symbols-outlined symbol-button" onClick={toggleEditDashboard}>
          settings
        </span>
      </div>
      <EditDashboardModal
        setShowSuccessAlert={setShowSuccessAlert}
        reportPermissions={reportPermissions}
        toggleEditDashboard={toggleEditDashboard}
        reportingId={reportingId}
        reportName={reportName}
        loadReports={loadReports}
      />
    </div>
  );
};

const AppliedButtonStyle = { backgroundColor: "#3E66FB", borderRadius: "7px" };

export const AddTags = ({
  toggleEditDashboard,
  reportingId,
  reportName,
  loadReports,
  optionsWorksTag,
  setShowTagModal,
  showTagModal,
  reportTags,
  userPermissions,
  setLoading,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <div className="symbol">
        <span className="material-symbols-outlined symbol-button" onClick={() => setShowTagModal(!showModal)}>
          new_label
        </span>
      </div>
      <AddTagModal
        setShowTagModal={setShowTagModal}
        showTagModal={showTagModal}
        optionsWorksTag={optionsWorksTag}
        toggleEditDashboard={toggleEditDashboard}
        reportingId={reportingId}
        reportName={reportName}
        loadReports={loadReports}
        setLoading={setLoading}
        reportTags={reportTags}
      />
    </div>
  );
};

const AddTagModal = ({
  setShowTagModal,
  showTagModal,
  toggleEditDashboard,
  reportingId,
  reportName,
  loadReports,
  optionsWorksTag,
  setLoading,
  reportTags,
}) => {
  return (
    <Modal show={showTagModal} onHide={() => setShowTagModal(false)} className="reporting-edit-dashboard" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <div>Add Tags🏷️</div>
          <div>
            <span style={{ color: "#3E66FB", fontSize: "20px" }}>{reportName}</span>
          </div>{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddTagFunction
          reportingId={reportingId}
          loadReports={loadReports}
          optionsWorksTag={optionsWorksTag}
          setShowTagModal={setShowTagModal}
          setLoading={setLoading}
          reportTags={reportTags}
        />
      </Modal.Body>
    </Modal>
  );
};

const EditDashboardModal = ({ toggleEditDashboard, reportPermissions, reportingId, reportName, loadReports, setShowSuccessAlert }) => {
  const isUserCanEditTemplate = reportPermissions.includes(PERMISSIONS["EDIT_REPORT"]);
  const isUserCanShareReport =
    reportPermissions.includes(PERMISSIONS["SHARE_REPORT_EXTERN"]) || reportPermissions.includes(PERMISSIONS["SHARE_REPORT_INTERN"]);

  if (!reportingId) {
    return <></>;
  }
  return (
    <Modal show={true} onHide={toggleEditDashboard} className="reporting-edit-dashboard" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <div>Edit Dashboard📝</div>
          <div>
            <span style={{ color: "#3E66FB", fontSize: "20px" }}>{reportName}</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs defaultActiveKey="campaign" id="fill-tab-example" className="mb-3" fill>
          {/* <Tab eventKey="campaign" title={<TabTitle icon={"tune"} text={"Campaign"} />}>
            <CampaignSettings />
          </Tab> */}
          {isUserCanEditTemplate && (
            <Tab eventKey="template" title={<TabTitle icon={"web"} text={"Template"} />}>
              <TemplateSettings
                reportingId={reportingId}
                toggleEditDashboard={toggleEditDashboard}
                setShowSuccessAlert={setShowSuccessAlert}
                loadReports={loadReports}
              />
            </Tab>
          )}
          {isUserCanShareReport && (
            <Tab eventKey="shared-user" title={<TabTitle icon={"manage_accounts"} text={"Shared User"} />}>
              <SharedUserSettings
                reportingId={reportingId}
                reportPermissions={reportPermissions}
                setShowSuccessAlert={setShowSuccessAlert}
                toggleEditDashboard={toggleEditDashboard}
              />
            </Tab>
          )}
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

const TabTitle = ({ text, icon }) => {
  return (
    <div className="tab-symbol-wrapper">
      <span className="material-symbols-outlined tab-symbol-button">{icon}</span>
      <label className="tab-symbol-text">{text}</label>
    </div>
  );
};

const convertArray = (arr) => {
  return arr.map((item) => item.value);
};

const AddTagFunction = ({ reportingId, loadReports, optionsWorksTag, setShowTagModal, reportTags }) => {
  const [store] = useStore();
  const [loading, setLoading] = useState(false);

  const optionsTag = (arr) => {
    return arr.map((item) => ({
      label: item.tag_name,
      value: parseInt(item.workspace_tag_id),
      report_id: reportingId,
    }));
  };

  const [selectedTags, setSelectedTags] = useState(optionsTag(reportTags));
  const getTagsToRemove = (oldTags, selectedTags) => {
    const difference = oldTags.filter((oldTag) => !selectedTags.some((selectedTag) => selectedTag.value === oldTag.value));
    return difference;
  };

  const deleteTags = getTagsToRemove(optionsTag(reportTags), selectedTags);
  const newTagsAdd = getTagsToRemove(selectedTags, optionsTag(reportTags));

  const updateTags = async () => {
    const link = `${getReportingLinks("reportTag")}${reportingId}/`;
    for (let i = 0; i < newTagsAdd.length; i++) {
      let data = { workspace_tag: newTagsAdd[i]["value"] };
      const response = await sendCallToAPI(link, store.accessToken, data, "PUT");
    }
    if (deleteTags.length > 0) {
      for (let i = 0; i < deleteTags.length; i++) {
        let data = { workspace_tag_id: deleteTags[i]["value"] };
        const response = await sendCallToAPI(link, store.accessToken, data, "DELETE");
      }
    }
    loadReports();
    setShowTagModal(false);
  };

  return (
    <>
      <LoadingScreen loading={loading}>
        <div className="content-block">
          <div className="content-item">
            <label>Select Working Tags:</label>
            <br></br>
            <Select
              isMulti
              isLoading={loading}
              value={selectedTags}
              options={optionsWorksTag.map((item) => ({
                label: item.name,
                value: item.id,
                report_id: reportingId,
              }))}
              onChange={(a, b) => setSelectedTags(a)}
            />
          </div>
        </div>
        <div>
          <br></br>
          <Button
            style={AppliedButtonStyle}
            disabled={newTagsAdd.length > 0 || deleteTags.length > 0 ? false : true}
            onClick={() => {
              setLoading(true);
              updateTags();
            }}
          >
            Apply
          </Button>
        </div>
      </LoadingScreen>
    </>
  );
};

const TemplateSettings = ({ reportingId, loadReports, toggleEditDashboard, setShowSuccessAlert }) => {
  const [store] = useStore();
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});

  let intial_run_count = 0;
  const [templateData, setTemplateData] = useState({});
  const [dataObject, setDataObject] = useState({
    hiddenTabs: [],
    selectedCampaigns: [],
    selectedPages: [],
    name: "",
    description: "",
  });

  const loadData = async () => {
    setLoading(true);
    const link = `${getReportingLinks("getEditReportTemplateSettings")}${reportingId}/`;
    const response = await sendCallToAPI(link, store.accessToken);
    let obj = { ...response };
    setTemplateData(obj);
    setDataObject(obj);
    setLoading(false);
    return response;
  };

  useEffect(() => {
    if (intial_run_count < 1) {
      intial_run_count++;
      loadData();
    }
  }, []);

  const updateReport = async () => {
    setLoading(true);
    const missingPages = dataObject["pages"].filter((pagesItem) => {
      const pagesFilter = dataObject["selected_pages"].some((selectedPagesItem) => pagesItem.value === selectedPagesItem.value);
      const hiddenPagesFilter = dataObject["hidden_pages"].some((hiddenItems) => pagesItem.name === hiddenItems.page_name);
      return !pagesFilter && !hiddenPagesFilter;
    });

    let hiddenPagesMaping = missingPages.map((item) => ({
      page_display_name: item.displayName,
      page_name: item.name,
      report: reportingId,
    }));

    let filteredDef = dataObject["hidden_pages"].filter((item) => !dataObject["selected_pages"].some((a) => a.name === item.page_name));

    let hiddenPages = [...filteredDef, ...hiddenPagesMaping];
    let selectedCam =
      dataObject["campaign_selected_options"].length > 0 ? dataObject["campaign_selected_options"].map((item) => item.value).join(",") : "";
    let preSelectCam =
      templateData["campaign_selected_options"].length > 0 ? templateData["campaign_selected_options"].map((item) => item.value).join(",") : "";

    let data = {};

    if (templateData?.name !== dataObject?.name) {
      data.name = dataObject.name;
    }
    if (templateData?.description !== dataObject?.description) {
      data.description = dataObject.description;
    }
    if (preSelectCam !== selectedCam) {
      data.filter = selectedCam;
    }
    data.hidden_pages = hiddenPages;

    const link = `${getReportingLinks("getEditReportTemplateSettings")}${reportingId}/`;

    const response = await sendCallToAPI(link, store.accessToken, data, "PUT");
    if (response.name) {
      loadReports();
      setShowSuccessAlert(true);
      toggleEditDashboard();
    } else {
      setLoading(false);
      alert("Having some problem during updating the data!");
    }
  };

  return (
    <div style={{ gap: "1rem", display: "flex", flexDirection: "column" }}>
      <LoadingScreen loading={loading}>
        <div className="content-block">
          <div className="content-item">
            <label>Choose Campaigns:</label>
            <Select
              isMulti
              isLoading={loading}
              value={dataObject["campaign_selected_options"]}
              options={dataObject["campaign_options"]}
              onChange={(v) => setDataObject((obj) => ({ ...obj, campaign_selected_options: v }))}
            />
            <ErrorField value={"selectedCampaigns"} errors={errors} />
          </div>
          <div className="content-item">
            <label>Pages:</label>
            <Select
              isMulti
              isLoading={loading}
              value={dataObject["selected_pages"]}
              options={dataObject["pages"]}
              onChange={(v) => setDataObject((obj) => ({ ...obj, selected_pages: v }))}
            />
            <ErrorField value={"selectedCampaigns"} errors={errors} />
          </div>
          <div className="content-item">
            <label>Name:</label>
            <div>
              <DebouncedInput value={dataObject["name"]} onChange={(v) => setDataObject((obj) => ({ ...obj, name: v }))} />
              <ErrorField value={"name"} errors={errors} />
            </div>
          </div>
          <div className="content-item">
            <label>Description:</label>
            <textarea
              rows={3}
              style={{
                border: "1px solid #abababff",
                borderRadius: "8px",
                padding: "5px",
                fontSize: "16px",
                backgroundColor: "white",
                color: "#333",
                outline: "none",
              }}
              value={dataObject["description"]}
              onChange={(e) => setDataObject((obj) => ({ ...obj, description: e.target.value }))}
            ></textarea>
            <ErrorField value={"description"} errors={errors} />
          </div>
        </div>
        <div>
          <Button
            style={AppliedButtonStyle}
            onClick={() => {
              updateReport();
            }}
          >
            Apply
          </Button>
        </div>
      </LoadingScreen>
    </div>
  );
};

const SharedUserSettings = ({ reportingId, toggleEditDashboard, setShowSuccessAlert, reportPermissions }) => {
  const [store] = useStore();
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState({ internal: [], external: [] });
  const [dataObject, setDataObject] = useState({ internal: [], external: [] });
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const SHARE_WITH_INTERN = reportPermissions?.includes(PERMISSIONS["SHARE_REPORT_INTERN"]);
  const SHARE_REPORT_EXTERN = reportPermissions?.includes(PERMISSIONS["SHARE_REPORT_EXTERN"]);
  const handleChange = (newValue) => {
    setEmails(newValue || []);
  };

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    if (event.key === "Enter" || event.key === "Tab" || event.metaKey) {
      if (inputValue.includes("@")) {
        setEmails((prev) => [...prev, { label: inputValue, value: inputValue }]);
      }

      setInputValue("");
      event.preventDefault();
    }
  };

  const loadData = async () => {
    const link = `${getReportingLinks("getEditReportSharedSettings")}${reportingId}/`;
    const res = await sendCallToAPI(link, store.accessToken);
    const tempOptions = { internal: res["internal_options"], external: res["external_options"] };
    const { int, ext } = res;
    setDataObject({ internal: int, external: ext });
    setOptions(tempOptions);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);
  const updateReport = async () => {
    const link = `${getReportingLinks("shareReport")}${reportingId}/`;
    let external_emails_for_invitation = emails;
    let data = dataObject;

    data["internal"] = data["internal"]?.length > 0 ? convertArray(data["internal"]) : null;
    data["external"] = data["external"]?.length > 0 ? convertArray(data["external"]) : null;
    data["emails_invite"] = external_emails_for_invitation?.length > 0 ? convertArray(external_emails_for_invitation) : [];
    try {
      const res = await sendCallToAPI(link, store.accessToken, data, "POST");
      const { external, internal, emails_invite } = res;
      alert(`${external ?? ""}${internal ? "\n" + internal : ""}${emails_invite ? "\n" + emails_invite : ""}`);
    } catch {
      alert("unexpected Error");
    }
    setShowSuccessAlert(true);
    toggleEditDashboard();
  };
  return (
    <div style={{ gap: "1rem", display: "flex", flexDirection: "column" }}>
      <LoadingScreen loading={loading}>
        <div>
          <label>Shared Report with Internal:</label>
          <Select
            isMulti
            options={options.internal}
            isDisabled={!SHARE_WITH_INTERN}
            value={dataObject.internal}
            onChange={(v) => setDataObject((obj) => ({ ...obj, internal: v }))}
          />
        </div>
        <div>
          <label>Shared Report with External:</label>
          <Select
            isMulti
            options={options.external}
            value={dataObject.external}
            isDisabled={!SHARE_REPORT_EXTERN}
            onChange={(v) => setDataObject((obj) => ({ ...obj, external: v }))}
          />
        </div>
        <div>
          <label>Send invitation to External:</label>
          <CreatetableSelect
            isMulti
            value={emails}
            inputValue={inputValue}
            onInputChange={setInputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            isDisabled={!SHARE_REPORT_EXTERN}
            components={{
              DropdownIndicator: null,
              IndicatorSeparator: null,
            }}
            menuIsOpen={false}
          />
        </div>
        <div>
          <Button
            style={AppliedButtonStyle}
            onClick={() => {
              updateReport();
            }}
          >
            Apply
          </Button>
        </div>
      </LoadingScreen>
    </div>
  );
};
